"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BookingStatus;
(function (BookingStatus) {
    BookingStatus["AWAITING"] = "awaiting";
    BookingStatus["OPEN"] = "open";
    BookingStatus["CLOSED"] = "closed";
    BookingStatus["CLOSED_NA"] = "closed_na";
    BookingStatus["CLOSED_CDS"] = "closed_cds";
    BookingStatus["COMPLETE"] = "complete";
    BookingStatus["DNA"] = "dna";
    BookingStatus["CANCELLED"] = "cancelled";
    BookingStatus["CANCELLED_REBOOK"] = "cancelled_rebook";
    BookingStatus["CANCELLED_NOT_ATTEND"] = "cancelled_not_attend";
    BookingStatus["CANCELLED_NO_INTEREST"] = "cancelled_no_interest";
})(BookingStatus = exports.BookingStatus || (exports.BookingStatus = {}));
//# sourceMappingURL=BookingStatus.enum.js.map